import { Plus } from "lucide-react";
import { FAQ } from "@/content/landing";
import Reveal from "./Reveal";

// <details> natif : accessible au clavier, sans état JS.
export default function Faq() {
  return (
    <section className="landing-section faq" id="faq">
      <Reveal className="section-intro"><span className="eyebrow">{FAQ.eyebrow}</span><h2>{FAQ.title}</h2></Reveal>
      <Reveal className="faq-list" delay={0.05}>
        {FAQ.items.map(item => (
          <details key={item.q}>
            <summary><span>{item.q}</span><Plus size={15} aria-hidden="true" /></summary>
            <p>{item.a}</p>
          </details>
        ))}
      </Reveal>
    </section>
  );
}
